// import blueContained from './blueContained';
import contained from "./contained";
import dropDown from "./dropdown";
import outlined from "./outlined";
import root from "./root";
import text from "./text";

export default {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: { ...root },
    containedSizeSmall: { ...contained.small },
    containedSizeFullWidth: { ...contained.fullWidth },
    containedSizeMedium: { ...contained.medium },
    containedSizeLarge: { ...contained.large },
    containedPrimary: { ...contained.primary },
    containedError: { ...contained.error },
    outlinedSizeSmall: { ...outlined.small },
    outlinedSizeLarge: { ...outlined.large },
    outlinedSizeMedium: { ...outlined.medium },
    outlinedSizeFullWidth: { ...outlined.fullWidth },
    outlinedPrimary: { ...outlined.primary },
    outlinedSecondary: { ...outlined.secondary },
    text: { ...text.base },
    textSizeFullWidth: { ...text.fullWidth },
    textSizeSmall: { ...text.small },
    textSizeMedium: { ...text.medium },
    textSizeLarge: { ...text.large },
    textPrimary: { ...text.primary },
    textSecondary: { ...text.secondary },
    dropDown: { ...dropDown.base },
  },
};
